import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light', // or 'dark'
    primary: {
      main: '#4B006E', // deep purple
    },
    secondary: {
      main: '#b7a57a', // tan accent
        },
    background: {
        default: '#f5f5f5', // optional: light gray background
    },
  },
  typography: {
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    fontSize: 16,
  },
});

export default theme;
